var cms_base_url = "https://cms.coveritup.in/";
const notifyBtn = document.getElementById("notify-out-of-stock-btn");
const notifyForm = document.getElementById("notify-out-of-stock");

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function showMessage(message, type) {
  $("#form-message").html(
    "<span style='color:" + type + "'>" + message + "</span>"
  );
  setTimeout(() => {
    $("#form-message").html("");
  }, 3000);
}

function IsEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function IsPhone(phone) {
  //var regex = /^([0-9]{10})+$/;
  var regex = /^([0-9])+$/;
  return regex.test(phone);
}//endIsPhone


$("#notify-out-of-stock").on("submit", function (r) {
  var form_id = "notify-out-of-stock";
  r.preventDefault();
  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  // js validation

  var email = jQuery("#" + form_id + " #email").val();
  if (email == "") {
    jQuery("#" + form_id + " #email").focus();
    showMessage("Please enter mobile number.", "red");
    return false;
  }
/*
  if (IsEmail(email) == false) {
    showMessage("Please enter valid email address.", "red");
    return false;
  }
*/
  
if (IsPhone(email) == false) {
    showMessage("Please enter valid mobile number.", "red");
    return false;
  }

  var product_id = jQuery("#" + form_id + " #product_id").val();
  if (product_id == "") {
    showMessage("Please select product varient.", "red");
    return false;
  }

  const formData = new FormData();
  formData.set("email", jQuery("#" + form_id + " #email").val());
  formData.set("product_id", jQuery("#" + form_id + " #product_id").val());
  formData.set(
    "product_handle",
    jQuery("#" + form_id + " #product_handle").val()
  );
  formData.set(
    "product_image_url",
    jQuery("#" + form_id + " #product_image_url").val()
  );

  formData.set("title", jQuery("#" + form_id + " #title").val());
  
  //alert(jQuery("#" + form_id + " #variant_title").val());


 setTimeout(() => {
    
   
   var variant_id2 = jQuery("#" + form_id + " #variant_id").val();
   var variant_title2 = jQuery("#" + form_id + " #variant_title").val();
  
   var variant_id = getUrlVars()["variant"];
   if(!variant_id){
     var variant_id=variant_id2;
   }
   var variant_title = jQuery("variant-option-value[for=option1]").html();
   if(!variant_title){
     var variant_title=variant_title2;
   }
   
  // alert(variant_id);
   //alert(variant_title);
  formData.set("variant_id",variant_id);
  formData.set("variant_title",variant_title);

  // js validation  end
  var post_url = cms_base_url + "api/form/stocknotification_post";

  fetch(post_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(formData),
  })
    .then((r) => r.json())
    .then((res) => {
      //   alert("Submitted successfully");
      showMessage("Submitted successfully", "green");
      notifyForm.reset();
      notifyForm.style.display = "none";
    notifyBtn.style.display = "block";

      
      if (!res.ok) console.error(res.message);
    })
    .catch(console.error);


  
  jQuery("#submit-btn-" + form_id).removeAttr("disabled");
  return false;

  }, 1000);
   
});

notifyBtn.onclick = function () {
  if (notifyForm.style.display == "none") {
    notifyForm.style.display = "block";
    notifyBtn.style.display = "none";
  }
};

 $(".block-swatch").click(function () {
         notifyForm.reset();
         notifyForm.style.display = "none";
          notifyBtn.style.display = "block";
    })

